export const ApiUrl = "https://sherwood.custom-ourbase.com/api";
export const baseUrl = "https://sherwood.custom-ourbase.com/";
